/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import { center }   from 'stylesheets/base.scss';
import Loader       from 'components/Loader/Loader.react';
import PropTypes    from 'prop-types';
import React        from 'react';
import styles       from './LoaderContainer.scss';


export default class LoaderContainer extends React.Component {
  constructor(props) {
    super();
    this.state = {
      close: false
    }
  }

  componentDidMount() {
    if (this.props.close) {
      this.setState({
        close: true
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      close: nextProps.hideAnimation
    });
  }


  render() {
    return (
      <div className={[styles.loaderContainer, this.props.browser ? styles.loaderContainerBrowser : null].join(' ')}>
        <div className={styles.children}>
          {this.props.children}
        </div>
        <Loader
          close={this.state.close ? true : null}
          inner={this.props.inner}
          page={this.props.page}
          specialPages={this.props.specialPages}
          browser={this.props.browser}
          className={center}
        />
      </div>
    );
  }
}

